module.exports = __webpack_public_path__ + "static/media/visualizar_icon.4b544fcf.svg";